'use strict';

var React = require('react');

var SvgBillingStatementRupeeFilledMajor = function SvgBillingStatementRupeeFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.32 16.467a.5.5 0 0 1-.32-.467v-11a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 1.5 1.5v11a.5.5 0 0 1-.872.334l-1.506-1.674a.495.495 0 0 0-.3-.16h-.144a.495.495 0 0 0-.3.16l-1.506 1.674a.5.5 0 0 1-.744 0l-1.506-1.674a.495.495 0 0 0-.3-.16h-.144a.495.495 0 0 0-.3.16l-1.506 1.674a.5.5 0 0 1-.551.133Zm6.569-3.324a.75.75 0 0 0-.246-1.032l-1.713-1.054a2.485 2.485 0 0 0 1.07-2.045v-.012h1.25a.75.75 0 0 0 0-1.5h-1.25v-1h1.25a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h1.75v1h-1.75a.75.75 0 0 0 0 1.5h1.75v.012a.988.988 0 0 1-.988.988c-.903 0-1.238 1.184-.47 1.657l2.815 1.732a.75.75 0 0 0 1.032-.246Z"
  }));
};
SvgBillingStatementRupeeFilledMajor.displayName = "BillingStatementRupeeFilledMajor";

exports.SvgBillingStatementRupeeFilledMajor = SvgBillingStatementRupeeFilledMajor;
